import React from 'react';
import { Star, ExternalLink, MapPin, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock';

const Testimonials = () => {
  // Google Place ID extracted from the Google Maps URL
  // URL: https://maps.app.goo.gl/9fdtKKm65ThqUqia6
  const googleMapsUrl = businessInfo.googleReviewsUrl;

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600">
            Real reviews from real customers in our community
          </p>
        </div>

        {/* Main Google Reviews Card */}
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden mb-8">
          {/* Header with Google branding */}
          <div className="bg-gradient-to-r from-teal-600 to-cyan-600 px-8 py-6 text-white">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <div className="bg-white rounded-full p-2">
                  <svg viewBox="0 0 24 24" width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold">Google Reviews</h3>
                  <p className="text-teal-100 text-sm">Family Laundry LLC</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                {[1,2,3,4,5].map((i) => (
                  <Star key={i} size={24} className="text-yellow-400 fill-yellow-400" />
                ))}
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-8 text-center">
            <div className="mb-6">
              <MessageSquare size={48} className="mx-auto text-teal-500 mb-4" />
              <h4 className="text-2xl font-semibold text-gray-800 mb-2">
                See What Our Customers Are Saying
              </h4>
              <p className="text-gray-600 max-w-lg mx-auto">
                We're proud to serve families throughout Gwinnett County. Read authentic reviews from our community on Google.
              </p>
            </div>

            {/* CTA Button */}
            <Button 
              onClick={() => window.open(googleMapsUrl, '_blank')}
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all"
              data-testid="google-reviews-btn"
            >
              <ExternalLink size={20} className="mr-2" />
              Read Our Google Reviews
            </Button>

            <p className="text-sm text-gray-500 mt-4">
              Opens in a new tab
            </p>
          </div>
        </div>

        {/* Service Area Info */}
        <div className="bg-teal-50 rounded-2xl p-6 text-center">
          <div className="flex items-center justify-center gap-2 text-teal-700 mb-2">
            <MapPin size={20} />
            <span className="font-semibold">Proudly Serving Gwinnett County</span>
          </div>
          <p className="text-gray-600 text-sm">
            Snellville • Lilburn • Lawrenceville • Norcross
          </p>
        </div>

        {/* Leave a Review CTA */}
        <div className="text-center mt-8">
          <p className="text-gray-600 mb-3">
            Had a great experience? We'd love to hear from you!
          </p>
          <Button 
            onClick={() => window.open(googleMapsUrl, '_blank')}
            variant="outline"
            className="border-teal-600 text-teal-600 hover:bg-teal-50"
            data-testid="leave-review-btn"
          >
            Leave Us a Review on Google
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
